import React from 'react';
import { Card, Table, Badge } from 'react-bootstrap';
import { Calendar, Clock, Coffee } from 'lucide-react';

const AttendanceHistory = ({ data = [] }) => {
    // Helper to format date nicely
    const formatDate = (dateString) => {
        const options = { weekday: 'short', month: 'short', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    // Helper to determine row color based on hours
    const getStatusColor = (hours) => {
        if (!hours || hours === 0) return 'secondary';
        if (hours < 4) return 'danger'; // Half day or less
        if (hours >= 9) return 'success'; // Potential Overtime
        return 'primary'; // Standard shift
    };

    return (
        <Card className="custom-card border-0 shadow-sm mt-4 overflow-hidden">
            <Card.Header className="bg-white border-0 pt-4 pb-0 d-flex align-items-center justify-content-between">
                <div>
                    <h5 className="fw-bold mb-0">Recent Attendance</h5>
                    <p className="text-muted small">Showing logs for the last 7 days</p>
                </div>
                <Calendar className="text-muted" size={20} />
            </Card.Header>
            
            <Card.Body className="p-0">
                <Table responsive hover className="mb-0 align-middle">
                    <thead className="bg-light">
                        <tr className="text-muted smaller text-uppercase">
                            <th className="ps-4 py-3">Date</th>
                            <th>Check In</th>
                            <th>Check Out</th>
                            <th>Work Hours</th>
                            <th className="pe-4 text-end">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ? (
                            data.map((log, i) => (
                                <tr key={i}>
                                    <td className="ps-4 fw-medium text-dark">
                                        {formatDate(log.date)}
                                    </td>
                                    <td>
                                        <div className="d-flex align-items-center gap-2">
                                            <Clock size={14} className="text-success" />
                                            {log.check_in || '--:--'}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="d-flex align-items-center gap-2">
                                            <Clock size={14} className="text-danger" />
                                            {log.check_out || '--:--'}
                                        </div>
                                    </td>
                                    <td className="fw-bold">
                                        {log.work_hours ? `${log.work_hours}h` : '0.00h'}
                                    </td>
                                    <td className="pe-4 text-end">
                                        <Badge 
                                            bg={getStatusColor(log.work_hours)} 
                                            className="px-2 py-1 fw-medium"
                                        >
                                            {log.work_hours >= 9 ? 'Overtime' : 
                                             log.work_hours >= 4 ? 'Full Day' : 
                                             log.work_hours > 0 ? 'Short Shift' : 'No Data'}
                                        </Badge>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="text-center py-5 text-muted">
                                    <div className="d-flex flex-column align-items-center gap-2">
                                        <Coffee size={32} className="text-light" />
                                        <span>No attendance logs found for this period.</span>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    );
};

export default AttendanceHistory;